module.exports = __webpack_public_path__ + "static/media/facebook.80b21044.svg";